import classNames from 'classnames';
import { Typography } from '../typography/typography';
import { Button } from '../form/button';

type TabNavRequest<T> = {
  className?: string;
  tabs: T[];
  selectedTabs: T[];
  onSelect: (req: { workFlowStatus?: T[] }) => void;
  getDisplayValue: (tab: T) => string;
};

export const ToggleTabNav = <T,>({ selectedTabs, onSelect, tabs, className, getDisplayValue }: TabNavRequest<T>) => {
  const selectedAll = selectedTabs.length === 0;

  function onTabChange(tab: T, action: 'add' | 'remove') {
    const allTabs = selectedAll ? [] : selectedTabs;
    let newTabs = action === 'add' ? [...allTabs, tab] : allTabs.filter((t) => t !== tab);

    if (newTabs.length === tabs.length) {
      newTabs = [];
    }

    onSelect({ workFlowStatus: newTabs });
  }

  function onAllTabChange() {
    if (selectedAll) {
      return;
    }

    onSelect({ workFlowStatus: undefined });
  }

  return (
    <div className={classNames('min-w-full mx-0 gap-[12px] flex items-left overflow-x-auto', className)}>
      <Button
        className={classNames({
          'button-tertiary': !selectedAll,
          'button-secondary !cursor-not-allowed': selectedAll,
        })}
        onClick={() => !selectedAll && onAllTabChange()}
      >
        <Typography type="text-sm">All</Typography>
      </Button>

      {tabs.map((tab, i) => {
        const isSelected = selectedTabs.includes(tab);
        const showAsSelected = isSelected || selectedAll;

        return (
          <Button
            key={i}
            className={classNames({
              'button-tertiary': !showAsSelected,
              'button-secondary': showAsSelected,
            })}
            onClick={() => onTabChange(tab, isSelected ? 'remove' : 'add')}
          >
            <Typography type="text-sm" className="whitespace-nowrap">
              {getDisplayValue(tab)}
            </Typography>
          </Button>
        );
      })}
    </div>
  );
};
